import React, { ComponentProps } from 'react'
import { FormattedMessage } from 'react-intl'

import { RecentTerms } from './RecentTerms'
import IconSearch from '@/checkout-instore-legacy/components/Commons/Icons/Search'
import getClassStyle from '@/checkout-instore-legacy/utils/getClassStyle'
import { mediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

type EmptySearchProps = ComponentProps<typeof RecentTerms>

export function EmptySearch({ recentTerms, updateTerm }: EmptySearchProps) {
  if (recentTerms && recentTerms.length > 0) {
    return <RecentTerms recentTerms={recentTerms} updateTerm={updateTerm} />
  }

  const tablet = mediaQuery({
    phone: false,
    tablet: true,
    desktop: true,
  })

  return (
    <div className="flex flex-column absolute h-100 w-100 justify-center tc">
      <div className="center mb5 mb7-ns">
        <IconSearch
          width={tablet ? 100 : 50}
          height={tablet ? 100 : 50}
          color={getClassStyle('c-muted-2', 'color')}
          animate={false}
        />
      </div>
      <div className="lh-copy f3-ns ph5 ph7-ns">
        <div className="gray">
          <FormattedMessage id="productNameReferenceOrEAN" />
        </div>
      </div>
    </div>
  )
}
